import React, { Component, useEffect } from "react";
import ChatBot from "react-simple-chatbot";
//import userImage from "../../images/user.svg";
import { ThemeProvider } from "styled-components";
import Post from "./Post";
import fav from "../../assets/favicon.ico";
import { agentKeyChatBot } from "../../src/slice/PrefixApi";
import chatPic from "../../assets/svg/address.svg";

const SimpleForm = () => {
  useEffect(() => {
    
    let dfMessenger = document.querySelector(' df-messenger');
    dfMessenger.addEventListener('df-messenger-loaded', () => {
      let chatIconIntervalId=setInterval(() => {
        let shadowRoot = dfMessenger.shadowRoot;
        if (shadowRoot) {
          let chatIcon = shadowRoot.querySelector('img.df-chat-icon')
          if (chatIcon) {
            chatIcon.style.height = "80px";
            chatIcon.style.width = "80px";
            chatIcon.style.left = "-11px";
            chatIcon.style.top = "-8px";
            clearInterval(chatIconIntervalId);
          }
        }
      }, 250)
    })
  }, []);

  // useEffect(()=>{
  //   const dfMessenger = document.querySelector('df-messenger');
  //   const df_chat_icon = document.querySelector('df_chat_icon');
  //   console.log(dfMessenger,"..........");
  //   dfMessenger.style.background_color = 'red';
  //   df_chat_icon.style.width = '90px';
  //   df_chat_icon.style.height = '96px'

  // },[])

  // console.log(agentKeyChatBot, "jjjjj");
  return (
    <df-messenger
      // chat-icon="https:&#x2F;&#x2F;redcliffelabs.com&#x2F;favicon.ico"
      chat-icon="https://staticcdn.redcliffelabs.com/media/gallary-file/None/48774221-7c23-40ed-90d1-f0fc771e1442.png"
      intent="WELCOME"
      chat-title="CareBuddy_dev"
      agent-id="cde47532-12b7-4124-ad73-008d5fd197ea"
      language-code="en"
    ></df-messenger>
  );
};

export default SimpleForm;
